import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'


const CaseManagerAllCases = lazy(() => import('./CaseManagerAllCases.jsx'))
const CaseManagerSingleView = lazy(() => import('./CaseManagerSingleView.jsx'))
const CaseManagerOngoingSingleView = lazy(() => import('./CaseManagerOngoingSingleView.jsx'))
const CaseManagerNationalInbox = lazy(() => import('./CaseManagerNationalInbox.jsx'))
const CaseManagerNationalInboxSingleView = lazy(() => import('./CaseManagerNationalInboxSingleView.jsx'))
const OfficerAssignSingleView = lazy(() => import('./OfficerAssignSingleView.jsx'))
const ResolveCaseSingleView = lazy(() => import('./ResolveCaseSingleView.jsx'))
const RejectedCaseSingleView = lazy(() => import('./RejectedCaseSingleView.jsx'))
const CaseManagerActivitiesTakenPage = lazy(() => import('./ProgressVisibility/ActivitiesTakenPage.jsx'))

const CaseManagerCaseManagementRoutes = [
    {
        path: '/CaseManagerNationalInbox',
        component: CaseManagerNationalInbox,
        auth: authRoleAccess.case_manager_cases,
    },
    {
        path: '/CaseManagerNationalInboxSingleView/:id',
        component: CaseManagerNationalInboxSingleView,
        auth: authRoleAccess.case_manager_cases,
    },
    {
        path: '/CaseManagerAllCases',
        component: CaseManagerAllCases,
        auth: authRoleAccess.case_manager_cases,
    },

    {
        path: '/CaseManagerSingleView/:id',
        component: CaseManagerSingleView,
        auth: authRoleAccess.case_manager_cases,
    },

    {
        path: '/OfficerAssignSingleView/:id',
        component: OfficerAssignSingleView,
        auth: authRoleAccess.case_manager_cases,
    },

    {
        path: '/CaseManagerOngoingSingleView/:id',
        component: CaseManagerOngoingSingleView,
        auth: authRoleAccess.case_manager_cases,
    },
    {
        path: '/CaseManagerOngoingSingleView/activities-taken/:id',
        component: CaseManagerActivitiesTakenPage,
        auth: authRoleAccess.case_manager_cases,
    },

    {
        path: '/ResolveCaseSingleView/:id',
        component: ResolveCaseSingleView,
        auth: authRoleAccess.case_manager_cases,
    },

    {
        path: '/RejectedCaseSingleView/:id',
        component: RejectedCaseSingleView,
        auth: authRoleAccess.case_manager_cases,
    },
]

export default CaseManagerCaseManagementRoutes 